import React, { useEffect, useCallback } from "react";
import { useHistory } from "react-router-dom";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import { carBrands } from "../../AppConstants";
import BodyContainer from "../Common/BodyContainer/BodyContainer";

const useStyles = makeStyles((theme) => ({
  contentWrapper: {
    width: "75%",
    margin: "auto",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      padding: "0px 15px"
    },
  },
  buttonRow: {
    display: "flex",
    flexDirection: 'column',
    flexWrap: "nowrap",
    gap: theme.spacing(2),
    justifyContent: "center",
    marginTop: theme.spacing(2),
  },
  button: {
    width: "100%",
    backgroundColor: "white",
    border: "3px solid black",
    color: "black",
    boxShadow: "none",
    borderRadius: "0px",
    padding: "20px",
    fontWeight: "600",
    "&:hover": {
      backgroundColor: "black",
      color: "white",
      boxShadow: "none",
    },
  },
}));

export default function Brand(props) {
  const history = useHistory();
  const { brand, reactGA, switchTheme } = props;
  const classes = useStyles();
  const fontFamily =
    brand?.name === carBrands.jaguar.title ? "Jaguar-Secondary" : "LandRover-Secondary";

  const handleSelect = useCallback(
    (carType) => {
      reactGA.event({
        category: "Appointment Type",
        action: "Select",
        label: carType,
      });
      history.push(`${brand.link}/${carType}`, { carCondition: carType });
    },
    [reactGA, brand?.link, history]
  );

  useEffect(() => {
    if (brand?.title === carBrands.jaguar.title) {
      switchTheme();
    }
  }, [brand?.title, switchTheme]);

  return (
    <BodyContainer
      {...props}
      childComponent={
        <React.Fragment>
          <div className={classes.contentWrapper}>
            <div className="col">
              <h4
                style={{
                  fontFamily: brand?.name === carBrands.jaguar.title ? "Jaguar" : "LandRover",
                  textTransform: "none", paddingBottom: "10px", marginTop: "20px"
                }}
              >
                Maak een keuze
              </h4>
            </div>
            <div className={classes.buttonRow}>
              <Button
                variant="contained"
                color="primary"
                className={classes.button}
                style={{ fontFamily }}
                onClick={() => handleSelect("new")}
              >
                New
              </Button>
              <Button
                variant="contained"
                color="primary"
                className={classes.button}
                style={{ fontFamily }}
                onClick={() => handleSelect("used")}
              >
                Used
              </Button>
            </div>
          </div>
        </React.Fragment>
      }
    />
  );
}
